import { store } from '@betacrew/jars-flux'
import { put, takeEvery, all, call, takeLatest } from 'redux-saga/effects';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { COMMON_EXPORTING_STATES, COMMON_LOADING_STATES, PAGE_STATE } from '../../constants/constants';
import HistoryDataService from '../../../../services/HistoryDataService';
import { componentKey, setBifurcatedPrepayAmount, setExportFile, setLoadingState, setTotalTransactions, setTransactions } from './PrePayHistorySlice';
import Payer from '../../../../libs/utility/Payer';
import General from '../../../../libs/utility/General';

export const { getTransactions, processRefundRequest, exportPrepayExcel, getAdminAndMemberPrepay } = {
    getTransactions: (payload) => {
        return {
            type: "PREPAY/GET_TRANSACTIONS",
            payload: payload
        }
    },
    processRefundRequest: (payload) => {
        return {
            type: "PREPAY/PROCESS_REFUND_REQUEST",
            payload: payload
        }
    },
    exportPrepayExcel: (payload) => {
        return {
            type: "PREPAY/EXPORT_PREPAY_EXCEL",
            payload: payload
        }
    },
    getAdminAndMemberPrepay: (payload) => {
        return {
            type: "PREPAY/GET_ADMIN_MEMBER_PREPAY",
            payload: payload
        }
    },
}

function* getTransactionsAsync(action) {
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING, message: "Getting History......" }));
        const response = yield HistoryDataService.GetPrepayHistoryData(action.payload);
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setTransactions([...General.extractDataFromResponseData(response.data)]));
            yield put(setTotalTransactions(General.extractPaginationTotalFromResponse(response.data)));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
    }
}

function* processRefundRequestAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Processing Refund Request......" }));
        const response = yield HistoryDataService.ProcessRefundRequest();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(addNotifications({
                heading: response?.data?.Message,
                message: response?.data?.Data,
                variant: TOASTER_VARIANT.SUCCESS
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* exportPrepayExcelAsync() {
    try {
        yield put(setLoadingState({ state: COMMON_EXPORTING_STATES.EXPORT_LOADING, message: "Exporting Excel......" }));
        const response = yield HistoryDataService.GetPrepayExport();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setExportFile(response.data.Data))
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_EXPORTING_STATES.EXPORT_READY }))
    }
}

function* getAdminAndMemberPrepayAsync(action){
    try {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_LOADING }));
        const response = yield HistoryDataService.GetAdminAndMemberPrepay();
        if (response?.data?.Status && response.data.Status === 1) {
            yield put(setBifurcatedPrepayAmount({
                memberPrepay: response?.data?.Data?.MemberAmount ?? 0,
                adminPrepay: response?.data?.Data?.AdminAmount ?? 0,
            }))
        }else{
            yield put(addNotifications({
                heading: "Error,",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: COMMON_LOADING_STATES.GRID_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getTransactions().type, getTransactionsAsync),
        takeLatest(processRefundRequest().type, processRefundRequestAsync),
        takeLatest(exportPrepayExcel().type, exportPrepayExcelAsync),
        takeLatest(getAdminAndMemberPrepay().type, getAdminAndMemberPrepayAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);